const { Component } = Shopware;
const utils = Shopware.Utils;

Component.extend('acris-faq-group-create', 'acris-faq-group-detail', {
    beforeRouteEnter(to, from, next) {
        if (to.name.includes('acris.faq.group.create') && !to.params.id) {
            to.params.id = utils.createId();
            to.params.newItem = true;
        }

        next();
    },

    methods: {
        getEntity() {
            this.item = this.repository.create(Shopware.Context.api);
            this.item.groupDisplay = 'belowListing';
            this.item.nameDisplay = 'hide';
            this.item.descriptionDisplay = 'hide';
            this.item.displayFoldable = 'config';
            this.item.cmsPageDisplayType = 'all';
        },

        saveFinish() {
            this.isSaveSuccessful = false;
            this.$router.push({ name: 'acris.faq.group.detail', params: { id: this.item.id } });
        },

        onClickSave() {
            this.isLoading = true;
            const titleSaveError = this.$tc('acris-faq-group.detail.titleSaveError');
            const messageSaveError = this.$tc('acris-faq-group.detail.messageSaveError');
            const titleSaveSuccess = this.$tc('acris-faq-group.detail.titleSaveSuccess');
            const messageSaveSuccess = this.$tc('acris-faq-group.detail.messageSaveSuccess');

            this.repository
                .save(this.item, Shopware.Context.api)
                .then(() => {
                    this.isLoading = false;
                    this.createNotificationSuccess({
                        title: titleSaveSuccess,
                        message: messageSaveSuccess
                    });
                    this.$router.push({ name: 'acris.faq.group.detail', params: { id: this.item.id } });
                }).catch(() => {
                    this.isLoading = false;
                    this.createNotificationError({
                        title: titleSaveError,
                        message: messageSaveError
                    });
                });
        }
    }
});
